import Postmate from "postmate"
import { useCallback, useEffect, useState } from "react"

import { ServicesConfig } from "../../typings/ServicesConfig"

export const usePostmate = ({
  setSearchQuery,
  setServicesConfig,
}: {
  setSearchQuery: (query: string) => void
  setServicesConfig: (servicesConfig: ServicesConfig) => void
}) => {
  const [parent, setParent] = useState<Postmate.ChildAPI>()

  useEffect(() => {
    if (parent) return

    const handshake = new Postmate.Model({
      SEARCH_EVENT: setSearchQuery,
      SET_SERVICES_CONFIG: setServicesConfig,
    })

    const handshakeTimeout = new Promise((resolve) =>
      setTimeout(resolve, 10000),
    )
    Promise.race([handshakeTimeout, handshake.then(setParent)])
  }, [parent, setSearchQuery, setServicesConfig])

  const emit = useCallback(
    (event: string, payload: { [key: string]: unknown }) => {
      if (parent && parent.emit) {
        parent.emit(event, payload)
      }
    },
    [parent],
  )

  return {
    emit,
  }
}
